import React, { useState, memo, useEffect } from 'react';

import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ptBR } from 'date-fns/locale';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { createMuiTheme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';

import { toastr } from 'react-redux-toastr';
import { FilterCreators } from '../../../store/actions/filter';
import DownloadGraphics from '../../DownloadGraphics/DownloadGraphics';
import InputDropdown from '../../../bergmannsoft/components/Widgets/Forms/InputDropdown';
import Toggle from '../../Elements/Toggle';

import { TagActions } from '../../../store/actions/tags';
import { VariableActions } from '../../../store/actions/variables';

import webchat from '../../../assets/images/webchat_icon.svg';
import messenger from '../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../assets/images/whatsapp_icon.svg';
import outlinePlus from '../../../assets/images/icon_add_blue.svg';
import outlineDelete from '../../../assets/images/icon_delete_red.svg';

import './FilterData.css';

const DAY_IN_MILLISECOND = 24 * 60 * 60 * 1000;

const FilterData = (props) => {
  const {
    infoStateFilter,
    onClickFilter,
    startDate: initialDate,
    endDate: finalDate,
    vlSelect: filterValue,
    tags: tagsList,
    channels: channelsList,
    variables: variablesList,
    hasMargin,
    graphicReference,
    graphicName,
    showDownload,
    showMoreFilters,
    isTagGraphic,
    bot,
    user,
  } = props;

  const { tags } = useSelector((state) => state.tags.tagsState);
  const { variables } = useSelector((state) => state.variables.variablesState);
  const allTags = [...tags.bot, ...tags.global];

  const dispatch = useDispatch();

  useEffect(() => {
    if (bot) {
      dispatch(TagActions.list({ botId: bot }));
      dispatch(VariableActions.list({ botId: bot }));
    }
  }, [bot, dispatch]);

  const isCorrectPeriod = (start, end) => {
    const diff = new Date(end) - new Date(start);
    const periodDays = Math.floor(diff / DAY_IN_MILLISECOND);

    if (periodDays > 31) {
      toastr.error('Erro', 'Por favor, escolha um período inferior a 31 dias.');
      return true;
    }
    if (periodDays < 0) {
      toastr.error(
        'Erro',
        'Por favor, escolha um período com data de inicio menor que a de fim.'
      );
      return true;
    }
    return false;
  };

  const [startDate, setStartDate] = useState(initialDate);
  const [endDate, setEndDate] = useState(finalDate);
  const [moreFilters, setMoreFilters] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [selectedTagFilter, setSelectedTagFilter] = useState(
    tagsList.length !== 0
  );
  const [selectedChannelFilter, setSelectedChannelFilter] = useState(
    channelsList.length !== 0
  );
  const [selectedVariableFilter, setSelectedVariableFilter] = useState(
    variablesList.length !== 0
  );

  const [periodError, setPeriodError] = useState(
    isCorrectPeriod(startDate, endDate)
  );
  const [vlSelect, setVlSelect] = useState(filterValue);
  const [currentVariableName, setCurrentVariableName] = useState('');
  const [currentVariableValue, setCurrentVariableValue] = useState('');

  const [checkedTags, setCheckedTags] = useState(tagsList);
  const [checkedNameTags, setCheckedNameTags] = useState(
    tagsList.map((id) => allTags.find((tag) => tag._id === id).name)
  );
  const [usedVariables, setUsedVariables] = useState(variablesList);
  const [activeChannels, setActiveChannels] = useState(channelsList);

  useEffect(() => {
    if (endDate === null) {
      setEndDate(new Date().toUTCString());
    }

    if (startDate === null) {
      setStartDate(new Date().toUTCString());
    }

    infoStateFilter(
      startDate,
      endDate,
      vlSelect,
      checkedTags,
      checkedNameTags,
      activeChannels,
      usedVariables
    );
  }, []);

  useEffect(() => {
    infoStateFilter(
      startDate,
      endDate,
      vlSelect,
      checkedTags,
      checkedNameTags,
      activeChannels,
      usedVariables
    );
  }, [
    endDate,
    infoStateFilter,
    startDate,
    vlSelect,
    checkedTags,
    checkedNameTags,
    activeChannels,
    usedVariables,
  ]);

  useEffect(() => {
    if (!selectedTagFilter) {
      setCheckedTags([]);
      setCheckedNameTags([]);
    }
  }, [selectedTagFilter]);

  const changeStartDate = (newStartDate) => {
    setVlSelect('costumizado');
    setStartDate(newStartDate);
    setPeriodError(isCorrectPeriod(newStartDate, endDate));
  };

  const changeEndDate = (newEndDate) => {
    setVlSelect('costumizado');
    setEndDate(newEndDate);
    setPeriodError(isCorrectPeriod(startDate, newEndDate));
  };

  const changeSelect = (event) => {
    const newDateStart = new Date();
    if (event.target.value === '1') {
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 1));
      setStartDate(nDate);
      setEndDate(new Date());
      setPeriodError(false);
      setVlSelect('1');
    } else if (event.target.value === '7') {
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 7));
      setStartDate(nDate);
      setEndDate(new Date());
      setPeriodError(false);
      setVlSelect('7');
    } else if (event.target.value === '15') {
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 15));
      setStartDate(nDate);
      setEndDate(new Date());
      setPeriodError(false);
      setVlSelect('15');
    } else if (event.target.value === '30') {
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 30));
      setStartDate(nDate);
      setEndDate(new Date());
      setPeriodError(false);
      setVlSelect('30');
    } else if (event.target.value === '45') {
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 45));
      setStartDate(nDate);
      setEndDate(new Date());
      setVlSelect('45');
    } else if (event.target.value === 'costumizado') {
      setStartDate(null);
      setEndDate(null);
      setVlSelect('costumizado');
    }
  };

  const updateDayPeriod = (event) => {
    if (event.target.value === '1') {
      const newDateStart = new Date();
      const nDate = new Date(new Date().setDate(newDateStart.getDate() - 1));
      setStartDate(nDate);
      setEndDate(new Date());
      setVlSelect('1');
    }
  };

  const onClickDate = async () => {
    setMoreFilters(false);
    await infoStateFilter(
      startDate,
      endDate,
      vlSelect,
      checkedTags,
      checkedNameTags,
      activeChannels,
      usedVariables
    );
    await onClickFilter();
  };

  const checkContainerMargin = () => {
    return hasMargin ? { marginTop: 0, marginBottom: 0 } : {};
  };

  const updateActiveChannels = (channel) => {
    if (activeChannels.length === 0) {
      setSelectedChannelFilter(true);
    }
    if (activeChannels.find((activeChannel) => activeChannel === channel)) {
      setActiveChannels(
        activeChannels.filter((activeChannel) => activeChannel !== channel)
      );
    } else {
      setActiveChannels([...activeChannels, channel]);
    }
  };

  const isAdminOrRoot = () =>
    user &&
    (user?.selectedCompany?.claim?.name === 'Admin' ||
      user?.selectedCompany?.claim?.name === 'Root');

  const getVariablesList = () => {
    return variables.bot.filter(
      ({ variableSensitivity }) =>
        variableSensitivity && variableSensitivity !== 'ENCRYPTED_DATA'
    );
  };

  const addNewVariable = () => {
    if (selectedVariableFilter && currentVariableName !== '') {
      const currentVariables = getVariablesList();
      const { variableSensitivity } = currentVariables.find(
        ({ name }) => name === currentVariableName
      );
      const cpyUsedVariables = [...usedVariables];
      cpyUsedVariables.unshift({
        name: currentVariableName,
        value: currentVariableValue,
        variableSensitivity,
      });
      setUsedVariables(cpyUsedVariables);
      setCurrentVariableName('');
      setCurrentVariableValue('');
    }
  };

  const removeNewVariable = (position) => {
    const updateUsedVariables = usedVariables.filter(
      (_, index) => position !== index
    );
    setUsedVariables(updateUsedVariables);
  };

  const defaultMaterialTheme = createMuiTheme({
    palette: {
      text: {
        primary: '#5e6876',
      },
      primary: {
        main: '#F38D45',
      },
    },
  });

  return (
    <div className="container-search" style={checkContainerMargin()}>
      <div className="search-ultimos-dias">
        <span className="search-filtrar-periodo">Filtrar Período:</span>
        <select
          value={vlSelect}
          onChange={changeSelect}
          onClick={updateDayPeriod}
        >
          <option value="1">Ultimas 24 horas</option>
          <option value="7">Ultimos 7 dias</option>
          <option value="15">Ultimos 15 dias</option>
          <option value="30">Ultimos 30 dias</option>
          <option value="costumizado">Data customizada</option>
        </select>
        <span>ou</span>
      </div>
      <div className="search-ultimos-dias">
        <span>de:</span>
        <MuiThemeProvider theme={defaultMaterialTheme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDateTimePicker
              value={startDate}
              ampm={false}
              onChange={changeStartDate}
              className="sub-input"
              format="dd/MM/yyyy HH:mm"
              disableFuture={false}
              invalidDateMessage="Data inválida"
              onError={(error) =>
                error ? setStartDateError(true) : setStartDateError(false)
              }
            />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>
      <div className="search-ultimos-dias">
        <span className="ml-2">até:</span>
        <MuiThemeProvider theme={defaultMaterialTheme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDateTimePicker
              autoOk
              ampm={false}
              value={endDate}
              onChange={changeEndDate}
              className="sub-input"
              format="dd/MM/yyyy HH:mm"
              disableFuture={false}
              invalidDateMessage="Data inválida"
              onError={(error) =>
                error ? setEndDateError(true) : setEndDateError(false)
              }
            />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>

      {showMoreFilters ? (
        <div
          className={`btn-mais-filtros ${
            selectedTagFilter || selectedChannelFilter || selectedVariableFilter
              ? 'mais-filtros-active'
              : ''
          }`}
          onClick={() => setMoreFilters(!moreFilters)}
          role="button"
          tabIndex="0"
        >
          {moreFilters ? (
            <>
              <span>menos filtros</span>
              <FontAwesomeIcon icon={faChevronUp} />
            </>
          ) : (
            <>
              <span>mais filtros</span>
              <FontAwesomeIcon icon={faChevronDown} />
            </>
          )}
        </div>
      ) : (
        <span className="filtro-space" />
      )}

      <div className="search-ultimos-dias">
        <button
          className="btn-filter-filter"
          onClick={onClickDate}
          disabled={startDateError || endDateError || periodError}
          type="button"
        >
          Filtrar
        </button>
        {showDownload ? (
          <DownloadGraphics
            refChartContainer={graphicReference}
            name={graphicName}
            isTagGraphic={isTagGraphic}
          />
        ) : (
          ''
        )}
      </div>
      {moreFilters ? (
        <div className="container-mais-filtros">
          <div className="mais-filtros-tags">
            <Toggle
              identifier="tags"
              checked={selectedTagFilter}
              onChange={() => {
                setSelectedTagFilter(!selectedTagFilter);
              }}
            />
            <span>Filtrar tags: </span>
            <InputDropdown
              className="dropdown-tags"
              placeholder="Buscar tags"
              dropdownItemsList={allTags}
              dropdownItemsChecked={checkedTags}
              onChange={(value) => {
                setCheckedTags(value);
                const names = value.map((id) => {
                  const tag_ = allTags.find((tag) => tag._id === id);
                  return tag_.name;
                });
                setCheckedNameTags(names);
              }}
              styleWidth="380px"
              useCheckbox
              disabled={!selectedTagFilter}
              messageNoItems="Não há tags cadastradas"
            />
          </div>
          <div className="mais-filtros-channels">
            <Toggle
              identifier="channels"
              checked={selectedChannelFilter}
              onChange={() => {
                if (selectedChannelFilter) {
                  setActiveChannels([]);
                }
                setSelectedChannelFilter(!selectedChannelFilter);
              }}
            />
            <span>Filtrar canais: </span>
            <div
              className={`mais-filtros-channel-icon ${
                activeChannels.find((channel) => channel === 'webchat')
                  ? 'active'
                  : ''
              }`}
              onClick={() => updateActiveChannels('webchat')}
              role="button"
              tabIndex="0"
            >
              <img src={webchat} alt="Canal Webchat" />
            </div>
            <div
              className={`mais-filtros-channel-icon ${
                activeChannels.find((channel) => channel === 'messenger')
                  ? 'active'
                  : ''
              }`}
              onClick={() => updateActiveChannels('messenger')}
              role="button"
              tabIndex="0"
            >
              <img src={messenger} alt="Canal Messenger" />
            </div>
            <div
              className={`mais-filtros-channel-icon ${
                activeChannels.find((channel) => channel === 'whatsapp')
                  ? 'active'
                  : ''
              }`}
              onClick={() => updateActiveChannels('whatsapp')}
              role="button"
              tabIndex="0"
            >
              <img src={whatsapp} alt="Canal Whatsapp" />
            </div>
          </div>
          <div className="mais-filtros-variables">
            <Toggle
              identifier="variables"
              checked={selectedVariableFilter}
              onChange={() => {
                if (selectedVariableFilter) {
                  setCurrentVariableName('');
                  setCurrentVariableValue('');
                  setUsedVariables([]);
                }
                setSelectedVariableFilter(!selectedVariableFilter);
              }}
            />
            <span>Filtrar por variáveis: </span>
            <InputDropdown
              className="dropdown-tags"
              placeholder="{variável}"
              value={currentVariableName}
              dropdownItemsList={getVariablesList()}
              onChange={(value) => setCurrentVariableName(value.name)}
              styleWidth="200px"
              disabled={!selectedVariableFilter}
              messageNoItems="Não há variáveis cadastradas"
            />
            <span>Valor:</span>
            <input
              className="mais-filtros-input"
              placeholder="Valor da variável aqui"
              value={currentVariableValue}
              onChange={(e) => setCurrentVariableValue(e.target.value)}
              onKeyPress={(e) => (e.key === 'Enter' ? addNewVariable() : null)}
              disabled={!selectedVariableFilter}
            />
            <img
              color="#1384FB"
              src={outlinePlus}
              alt="add-rule"
              onClick={() => addNewVariable()}
            />
          </div>
          <ul>
            {usedVariables.map((variable_, index) => (
              <li key={index}>
                <span className="variable-name-label">Variável:</span>
                <span className="variable-name">{variable_.name}</span>
                <span className="variable-value-label">Valor:</span>
                <span className="variable-value">{variable_.value}</span>
                <img
                  color="#1384FB"
                  src={outlineDelete}
                  alt="remove-rule"
                  onClick={() => removeNewVariable(index)}
                />
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    startDate: state.filter.startDate,
    endDate: state.filter.endDate,
    vlSelect: state.filter.vlSelect,
    tags: state.filter.tags,
    channels: state.filter.channels,
    variables: state.filter.variables,
    bot: state.bots && state.bots.bot && state.bots.bot._id,
    user: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...FilterCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterData));
